import { styled } from '@mui/material'

const RootElement = styled('div')(({ theme }) => ({
  width: '100%',
  ...theme.typography.body2,
  '& > :not(style) + :not(style)': {
    height: 'auto',
    backgroundColor: 'transparent',
    marginTop: theme.spacing(2),
  },
}))

export default RootElement
